module.exports = __webpack_public_path__ + "static/media/secured-loan.b9b0cf28.svg";